export default __webpack_public_path__ + "static/media/RecipeBookImage.2448891b.svg";